var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header',{attrs:{"score":_vm.score,"time":_vm.timer},on:{"reset-game":_vm.resetGame}}),_c('div',{staticClass:"main"},[_c('Board',{attrs:{"board":_vm.board}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }